var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gc-alert',{attrs:{"type":"success","text":""}},[_vm._v(_vm._s(_vm.$t('message.success.title')))])}
var staticRenderFns = []

export { render, staticRenderFns }